/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
// redux mapping
import { useDispatch, useSelector } from "react-redux";
import {
  buyPreview,
  favoriteApp,
  fetchAppDetail,
  fetchGroups,
  contactusApp,
} from "../../redux/reducers/store-detail-reducer";
import PageStore from "../../Components/Page/PageStore";
import {
  Card,
  Row,
  Col,
  Typography,
  Button,
  Image,
  Result,
  Modal,
  Form,
  Select,
} from "antd";
import styles from "./Components/Style.module.less";
import CardTabs from "./Components/CardTabs";
import { HeartOutlined, HeartFilled } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslate } from "../../Translate";
import {
  isManagement_app,
  isAppPublic,
  openNotificationWithIcon,
  handleLogError,
} from "../../Helpers/Helpers";
import Parser from "html-react-parser";
import TextArea from "antd/lib/input/TextArea";
import { AccountsService } from "../../Service/AccountsService";

const { Title, Paragraph } = Typography;
const { Option } = Select;

const AppDetail = (props) => {
  const navigate = useNavigate();
  const { type } = props;
  const { keycloak } = useKeycloak();
  const [filterGroups, setFilterGroups] = useState([]);
  const [favorite, setFavorite] = useState(false);
  const userid = keycloak?.tokenParsed?.sub?.toString();
  //gestione lingua
  const i18n = useTranslate();
  const { t } = i18n;
  const { id } = useParams();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [groupId, setGroupId] = useState(null);
  const [isBuy, setIsBuy] = useState(false);
  // set up dispatch
  const dispatch = useDispatch();
  // fetch data dal nostro store redux
  // destrutturiamo lo slice appDetail
  const { app, loading, error, groups, preview } = useSelector(
    (state) => state.appDetail
  );

  const [formModalRef] = Form.useForm();

  //hook to fetch single app
  useEffect(() => {
    dispatch(fetchAppDetail(keycloak.token, userid, id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchGroups());
  }, []);

  //hook to fetch items
  useEffect(() => {
    getNotice(error);
  }, [error]);

  useEffect(() => {
    ckIsBuy();
    setFavorite(app.preferita ? app.preferita : false);
  }, [app]);

  const ckIsBuy = () => {
    //verfico se è public
    if (app.length === 0) return false;
    if (app.contattoAttivazione) return false;
    if (!keycloak.authenticated) return false;
    const isPublic = isAppPublic(app.visibilitaGruppiId);
    if (isPublic) {
      //metto in questa variabile tutti i gruppi dell'utente
      let newFilterGroups = [...filterGroups];
      app?.appComprataDa.map((item) => {
        let indexFound = -1;
        newFilterGroups.forEach((element, index) => {
          if (parseInt(element.key) === item) {
            indexFound = index;
          }
        });
        if (indexFound !== -1) {
          newFilterGroups.splice(indexFound, 1);
        }
      });
      setFilterGroups(newFilterGroups);
      newFilterGroups?.length > 0 ? setIsBuy(true) : setIsBuy(false);
    } else {
      var newFilterGroupsNotPublic = [];
      app?.visibilitaGruppiId.forEach((item) => {
        var found = filterGroups.find((element, index) => {
          if (parseInt(element.key) === item) {
            return true;
          } else {
            return false;
          }
        });
        if (found) {
          newFilterGroupsNotPublic.push(found);
        }
      });
      setFilterGroups(newFilterGroupsNotPublic);
      if (newFilterGroupsNotPublic?.length > 0) {
        app?.appComprataDa.forEach((item) => {
          var indexFound = -1;
          newFilterGroupsNotPublic.forEach((element, index) => {
            if (parseInt(element.key) === item) {
              indexFound = index;
            }
          });
          if (indexFound !== -1) {
            newFilterGroupsNotPublic.splice(indexFound, 1);
          }
        });
        setFilterGroups(newFilterGroupsNotPublic);
      }
      newFilterGroupsNotPublic?.length > 0 ? setIsBuy(true) : setIsBuy(false);
    }
  };

  useEffect(() => {
    if (JSON.stringify(preview) === JSON.stringify({})) return;
    navigate("/store/preview/" + id + "@" + groupId);
  }, [preview]);

  useEffect(() => {
    /*carico la lookup degli accounts*/
    const lk_accounts = [];
    groups.map((account) => {
      if (type === "admin") {
        lk_accounts.push(
          <Option value={account[0]} key={account[0]}>
            {account[1].trim()}
          </Option>
        );
      } else if (
        keycloak.tokenParsed !== undefined &&
        keycloak.tokenParsed.accounts.indexOf(account[0]) !== -1 &&
        type !== "admin"
      ) {
        lk_accounts.push(
          <Option value={account[0]} key={account[0]}>
            {account[1].trim()}
          </Option>
        );
      }
      return account;
    });
    setFilterGroups(lk_accounts);
  }, [groups]);

  //const  app = apps?.content?.filter(app => app.id == id)[0];
  const skeleton =
    "data:image/jpeg;base64,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";
  //console.log(app);

  const showModal = () => {
    formModalRef.resetFields();
    setIsModalOpen(true);
  };

  const handleOk = () => {
    formModalRef
      .validateFields()
      .then((data) => {
        formModalRef.resetFields();
        setIsModalOpen(false);
        setGroupId(data.groupId);
        app.contattoAttivazione ? invia(data) : simulate(data.groupId);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const invia = (dataSend) => {
    dataSend["appId"] = app.id;
    console.log(dataSend);
    dispatch(contactusApp(keycloak.token, dataSend));
  };

  const simulate = (groupId) => {
    //prima della preview devo verificare se il gruppo ha valorizzato pec e codice sdi
    //dispatch(buyPreview(keycloak.token, userid, id, groupId));
    controlloPreSimulate(groupId);
  };

  const controlloPreSimulate = async (groupId) => {
    try {
      var filteredDataSend = {};
      filteredDataSend["type"] = type;
      const response = await AccountsService.getAccountById(
        keycloak.token,
        groupId,
        filteredDataSend
      );
      if (response.status === 500 || response.status === 0) {
        openNotificationWithIcon(
          "error",
          "Errore",
          t("errorapp") + "\n" + response.message ? response.message : ""
        );
      }  else if(response.status === 403 || response.status === 401){
        openNotificationWithIcon(
          "error",
          "Errore",
          t("errorapp") + "\n" + response.message ? response.message : ""
        );
      }
      var obj = response.data;
      if(obj.sdi ==="" || obj.pec === ""){
        openNotificationWithIcon(
          "warning",
          "Warning",
          "Valorizzare il codice SPI e la Pec prima di proseguire con l'acquisto del servizio."
        );
        return false;
      }
      dispatch(buyPreview(keycloak.token, userid, id, groupId));
    } catch (error) {
      handleLogError(error);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleAddFavorite = () => {
    dispatch(favoriteApp(keycloak.token, userid, id, favorite));
    setFavorite(!favorite);
  };

  const getNotice = (response) => {
    if (response.status) {
      if (response.code === 400 || response.code === 404) {
        openNotificationWithIcon(
          "warning",
          "Warning",
          <>{response.message ? response.message : ""}</>
        );
      } else if (response.code === 401) {
        openNotificationWithIcon(
          "warning",
          "Warning",
          response.message ? response.message : ""
        );
      } else {
        openNotificationWithIcon(
          "error",
          "Errore",
          t("errorapp") + "\n" + response.message ? response.message : ""
        );
      }
    } else {
      if (response.code === 200) {
        var msg = app.contattoAttivazione
          ? t("msgscontactus")
          : t("msgsaveapp");
        openNotificationWithIcon("success", "Success", msg);
        //navigate("/admin/store");
      }
    }
  };

  return (
    <PageStore loading={loading} inner>
      <Row>
        <Col offset={6}>
          <Card
            style={{
              width: 700,
              boxShadow: "5px 8px 24px 5px rgba(171, 171, 171, 0.6)",
              borderRadius: "5px",
            }}
            cover={
              <Image
                preview={false}
                width={700}
                height={350}
                src={app.iconaDettaglio ? app.iconaDettaglio : skeleton}
              />
            }
          >
            <Row>
              <Col span={24}>
                <Title
                  level={3}
                  style={{ color: "#8c8b8b", textAlign: "left" }}
                >
                  {app.titolo}
                </Title>
                <div className={styles.additionaldetail}>
                  <p>
                    <b>{t("author")}:</b>{" "}
                    <span className="author">{app.autore}</span>
                  </p>
                  <p style={{ marginLeft: "30px" }}>
                    <b>{t("activationdate")}:</b>{" "}
                    <span className="data">
                      {app.dataPubblicazione != null
                        ? new Intl.DateTimeFormat("it-IT", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                          }).format(new Date(app.dataPubblicazione))
                        : ""}
                    </span>
                  </p>
                </div>
                <Paragraph>
                  {app.descrizione ? Parser(app.descrizione) : ""}
                </Paragraph>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    color: "#E61E1E",
                  }}
                >
                  {keycloak.authenticated ? (
                    <>
                      <span
                        onClick={handleAddFavorite}
                        style={{
                          fontSize: "16px",
                          display: "inline-flex",
                          cursor: "pointer",
                        }}
                      >
                        {favorite ? (
                          <>
                            <HeartFilled
                              style={{ marginTop: "3px", fontSize: "22px" }}
                            />
                            &nbsp;
                            {t("removetofavorite")}
                          </>
                        ) : (
                          <>
                            <HeartOutlined
                              style={{ marginTop: "3px", fontSize: "22px" }}
                            />
                            &nbsp;
                            {t("addtofavorite")}
                          </>
                        )}
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                  {isManagement_app(keycloak) && isBuy ? (
                    <Button
                      type="primary"
                      style={{ width: "150px" }}
                      onClick={showModal}
                    >
                      {t("get")}&nbsp;
                      {app.prezzo != null
                        ? new Intl.NumberFormat("it-IT", {
                            style: "currency",
                            currency: "EUR",
                          }).format(app.prezzo)
                        : new Intl.NumberFormat("it-IT", {
                            style: "currency",
                            currency: "EUR",
                          }).format(0)}
                    </Button>
                  ) : (
                    ""
                  )}
                  {isManagement_app(keycloak) && app.contattoAttivazione ? (
                    <Button
                      type="primary"
                      style={{ width: "120px" }}
                      onClick={showModal}
                    >
                      {t("contactus").toUpperCase()}
                    </Button>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            </Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>
              <Col span={24}>
                <CardTabs app={app} />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <Modal
        title={app.contattoAttivazione ? t("contactustxt") : t("getgrouptxt")}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={app.contattoAttivazione ? t("send") : "OK"}
      >
        <Form
          preservare={false}
          form={formModalRef}
          name="modal-ref"
          layout="vertical"
          scrollToFirstError
        >
          <Form.Item
            name="groupId"
            label={t("group")}
            rules={[
              {
                required: true,
                message: t("ckGroup"),
              },
            ]}
          >
            <Select
              style={{ width: "100%" }}
              showSearch
              placeholder={t("selectgroup")}
              optionFilterProp="children"
              filterOption={(input, option) => option.children.includes(input)}
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              {filterGroups}
            </Select>
          </Form.Item>
          {app.contattoAttivazione ? (
            <Form.Item name="note" label={t("note")}>
              <TextArea></TextArea>
            </Form.Item>
          ) : (
            ""
          )}
        </Form>
      </Modal>
    </PageStore>
  );
};

export default AppDetail;
